var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { lighten } from '@mui/material';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { testId } from '../internal/testing';
const bgColor = ({ palette }) => (palette.mode === 'light' ? grey[400] : grey[800]);
const SpeechBubbleStyled = styled(Typography, {
    shouldForwardProp: (prop) => !['highlighted', 'hidden'].includes(prop)
}) `
    & {
        --bg-color: ${({ theme, highlighted, hidden }) => {
    let returnColor = bgColor(theme);
    if (highlighted) {
        returnColor = theme.palette.primary.main;
        if (hidden) {
            // Hidden and highlighted.
            returnColor = lighten(returnColor, 0.2);
        }
    }
    else if (hidden) {
        returnColor = theme.palette.actions.disabledBackground;
    }
    return returnColor;
}};

        --text-color: ${({ theme, highlighted, hidden }) => {
    let returnColor = theme.palette.text.primary;
    if (highlighted) {
        returnColor = theme.palette.common.white;
    }
    else if (hidden) {
        returnColor = theme.palette.text.secondary;
    }
    return returnColor;
}};
    }

    background-color: var(--bg-color);
    color: var(--text-color);
    margin-right: 50px;
    padding: 11px 20px;
    padding-right: ${({ hidden }) => (hidden ? '40px' : '20px')};
    border-radius: 20px;
    word-break: break-word;
    line-height: 1.4;
    position: relative;

    &:before {
        border-bottom-right-radius: 12px;
        border-left: 14px solid var(--bg-color);
        left: -5px;
    }

    &:after {
        background-color: ${({ theme }) => theme.palette.background.default};
        border-bottom-right-radius: 8px 24px;
        left: -5px;
        width: 5px;
    }

    &:before,
    &:after {
        bottom: -1px;
        content: '';
        height: 20px;
        position: absolute;
    }

    svg {
        position: absolute;
        right: 10px;
        top: 10px;
    }
`;
// We could directly export SpeechBubbleStyled but that will stop prop type generation from working.
export const SpeechBubble = (props) => {
    const { highlighted, hidden, children } = props, other = __rest(props, ["highlighted", "hidden", "children"]);
    return (_jsxs(SpeechBubbleStyled, Object.assign({}, other, { "aria-description": 'Hidden message', highlighted: highlighted, hidden: hidden, "data-testid": testId('speech-bubble', {
            highlighted: Boolean(highlighted),
            hidden: Boolean(hidden)
        }), children: [children, hidden && _jsx(VisibilityOffOutlinedIcon, { "data-testid": 'speech-bubble-visibility-off' })] })));
};
